import { useTranslation } from 'react-i18next'

import { Card, CardTitle } from '@reveni-io/reveni-ui'

import ShippingCost from '@/parcels/components/ShippingCost/ShippingCost'
import ShippingCostInbound from '@/parcels/components/ShippingCostInbound/ShippingCostInbound'

const ShippingCostCard = ({
  isInbound,
  currency,
  total,
  base,
  duties,
  tax,
  currencyAdjustment,
  handlingFees,
  additionalProducts,
}) => {
  const { t } = useTranslation()

  return (
    <Card showBorder={false}>
      <CardTitle>{t('Coste del envío')}</CardTitle>
      {isInbound ? (
        <ShippingCostInbound currency={currency} total={total} base={base} additionalProducts={additionalProducts} />
      ) : (
        <ShippingCost
          currency={currency}
          total={total}
          base={base}
          duties={duties}
          tax={tax}
          currencyAdjustment={currencyAdjustment}
          handlingFees={handlingFees}
        />
      )}
    </Card>
  )
}

export default ShippingCostCard
